/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchActivity} from '../api'

export const useMutationSearchActivity = createReactQueryMutationHook('searchActivity', searchActivity)
